
import { GETTIMELINE_SUCCESS, GETTIMELINE_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getTimelineReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETTIMELINE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETTIMELINE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getTimelineReducer;

